
import { UserInfo } from "@/models/dossier/user-info";
import { TaskAssignedUser } from "@/models/tasks/assigned-user";
import { Task, TaskStatus} from "@/models/tasks/task";
import { TaskUnreadUser } from "@/models/tasks/task-unread-user";
import { AuthService } from "@/services/auth-service";
import { DossierService } from "@/services/dossier-service";
import Vue from "vue";
import { MainSocketService } from "../../services/main-socket-service";
import AppTimeago from "@/components/common/Timeago.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => Task,
			required: true
		},
	},
	computed: {
		hasUnread(): Boolean {
			if (!AuthService.wfUser){
				return false;
			}
			return this.value.hasUnreadMessages(AuthService.wfUser.ID);
		},
		statusClass(): string {
			if (this.value.Status == TaskStatus.PENDING) {
				return "info";
			}
			if (this.value.Status == TaskStatus.UNCONFIRMED) {
				return "warning";
			}
			return "success";
		},
		locale(): string {
			return this.$i18n.locale;
		},
		users():UserInfo[] {
			return this.value.AssignedUsers.map(u => DossierService.users.find(user => u.UserID == user.ID) as UserInfo).filter(u => u);
		}
	},
	methods: {
		open() {
			this.$emit("open");
		},
		onMessageUnread(data: any) {
			let m = new TaskUnreadUser(data);
			this.value.MessagesUnreadUsers.push(m);
		},
		onMessageRead(data: any) {
			let m = new TaskUnreadUser(data);
			let i = this.value.MessagesUnreadUsers.findIndex(u => u.ID == m.ID);
			if (i != -1) {
				this.value.MessagesUnreadUsers.splice(i, 1);
			}
		},
		onTaskUpdate(data: any) {
			let task = new Task(data);
			this.$emit("input", task);
		},
		onUserAssigned(data:any) {
			let assignedUser = new TaskAssignedUser(data);
			this.value.AssignedUsers.push(assignedUser);
		},
		onAssignedUserremoved(data:any) {
			let assignedUser = new TaskAssignedUser(data);
			let i = this.value.AssignedUsers.findIndex(a => a.ID == assignedUser.ID);
			if (i != -1) {
				return this.value.AssignedUsers.splice(i, 1);
			}
		}
	},
	async created() {
		await DossierService.getUsers();
		MainSocketService.on(`/tasks/${this.value.ID}/message/unread`, this.onMessageUnread, this);
		MainSocketService.on(`/tasks/${this.value.ID}/message/read`, this.onMessageRead, this);
		MainSocketService.on(`/task/${this.value.ID}/assigned-users/new`, this.onUserAssigned, this);
		MainSocketService.on(`/task/${this.value.ID}/assigned-users/delete`, this.onAssignedUserremoved, this);
		MainSocketService.on(`/tasks/${this.value.ID}`, this.onTaskUpdate, this);
	},
	destroyed() {
		MainSocketService.offAll(this);
		MainSocketService.offAll(this);
		MainSocketService.offAll(this);
		MainSocketService.offAll(this);
		MainSocketService.offAll(this);
	},
	components: {
		AppTimeago
	}
});
